"use strict";

import VueBootstrap from './vue_application/bootstrap';
import slick from './modules/slick';
import modal from './modules/modal';
import rsFormBundleLoader from './modules/loadRsForm';

VueBootstrap('#app');

rsFormBundleLoader(
    require('exports?RSFormPro,' +
        'rsfp_addEvent,' +
        'ajaxExtraValidationScript,' +
        'ajaxDisplayValidationErrors,' +
        'RSClickedSubmitElement,' +
        'ajaxValidation,' +
        'RSFormProUtils,' +
        'rsfp_getForm!../../../../media/com_rsform/js/script')
);

'use strict';
(function ($) {
    $(document).ready(function () {

        const BODY = $('body');

        // Popups
        new modal('.popup', '.popup-content', {
            overlayClose: false
        });

        // console.log(RSFormPro);

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        /*Support placeholder*/
        (function () {
            $('input, textarea').placeholder();
        }());
        // ie9
        BODY.on('change, click', function () {
            (function () {
                $('input, textarea').placeholder();
            }());
        });
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        //слайдер: главный, партнеры
        (function () {
            var $sliderMain = $('.slider-main');

            if ($sliderMain.length) {
                slick('.slider-partners ul', {
                    slidesToShow: 5,
                    variableWidth: true
                });

                slick($sliderMain, {
                    speed: 500,
                    fade: true
                });
                $sliderMain.find('article').each(function (e) {
                    var src = $(this).attr('data-src');
                    $(this).css({backgroundImage: "url(" + src + ")"});
                });

                // Стилизация заголовков
                $sliderMain.find('h1.title').each(function (i, el) {
                    var $el = $(el);
                    var text = $el.text().trim().split(' ');
                    var first = text.shift();

                    $el.html((text.length ? '<strong>' + first + '</strong>' : first) + ' ' + text.join(' '));
                });

                // позиционирование стрелок
                var left = $sliderMain.find('.inner-wrapper').offset().left - 15,
                    right = left + $sliderMain.find('.inner-wrapper').width();
                $sliderMain.find('.slick-prev').css({left: left + "px"});
                $sliderMain.find('.slick-next').css({left: right + "px"});
            }
        })();
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        // позиционирование блока контакты
        (function () {
            if ($('.map-contacts').length) {
                var left = BODY.width() / 2;
                $('.map-contacts').css({left: (left - 400) + "px"});
            }
        })();
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        // добавление адптивных стрелок к навигации в сайдбаре
        $('.active').parent().css({display: 'block'});
        $('.category-nav .child > li').append('<div class="arrow"></div>');
        $('.category-nav .child > li').each(function (e) {
            var size = $(this).outerHeight() / 2;
            $(this).find(".arrow").css({
                borderTop: size + "px solid transparent",
                borderBottom: size + 'px solid transparent',
                borderLeft: 12.5 + 'px solid #660a18'
            });
        });


        // раскрывающийся список (страница: Услуги по регистрации)
        $('.list-registration .parent').on('click', function () {
            if ($(this).hasClass("open") == false) {
                $(this).addClass('open').find('.child').slideDown();
            } else if ($(this).hasClass("open") == true) {
                $(this).removeClass('open').find('.child').slideUp();
            }
        });
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        // костыль, создание 2 колонок ie9+ (страница: Услуга по регистрации)
        $(function () {
            var num_cols = 2,
                container = $('.list-registration'),
                listItem = '.parent',
                listClass = 'sub-list';
            container.each(function () {
                var items_per_col = new Array(),
                    items = $(this).find(listItem),
                    min_items_per_col = Math.floor(items.length / num_cols),
                    difference = items.length - (min_items_per_col * num_cols);
                for (var i = 0; i < num_cols; i++) {
                    if (i < difference) {
                        items_per_col[i] = min_items_per_col + 1;
                    } else {
                        items_per_col[i] = min_items_per_col;
                    }
                }
                for (var i = 0; i < num_cols; i++) {
                    $(this).append($('<ul ></ul>').addClass(listClass));
                    for (var j = 0; j < items_per_col[i]; j++) {
                        var pointer = 0;
                        for (var k = 0; k < i; k++) {
                            pointer += items_per_col[k];
                        }
                        $(this).find('.' + listClass).last().append(items[j + pointer]);
                    }
                }
            });
        });

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        //плавная прокрутка к якорю
        if ($('#contacts').length) {
            anchor('#header nav li:last-child a', 700);
        }
        function anchor(elem, time) {
            $(elem).on('click', function () {
                $("html, body").animate({
                    scrollTop: $($(this).attr("href")).offset().top + "px"
                }, {
                    duration: time,
                    easing: "swing"
                });
                return false;
            });
        }

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        // костыль, создание 3 колонок ie9+
        $(function () {
            var num_cols = 3,
                container = $('.form-services-block ul'),
                listItem = 'li',
                listClass = 'sub-list';
            container.each(function () {
                var items_per_col = new Array(),
                    items = $(this).find(listItem),
                    min_items_per_col = Math.floor(items.length / num_cols),
                    difference = items.length - (min_items_per_col * num_cols);
                for (var i = 0; i < num_cols; i++) {
                    if (i < difference) {
                        items_per_col[i] = min_items_per_col + 1;
                    } else {
                        items_per_col[i] = min_items_per_col;
                    }
                }
                for (var i = 0; i < num_cols; i++) {
                    $(this).append($('<ul ></ul>').addClass(listClass));
                    for (var j = 0; j < items_per_col[i]; j++) {
                        var pointer = 0;
                        for (var k = 0; k < i; k++) {
                            pointer += items_per_col[k];
                        }
                        $(this).find('.' + listClass).last().append(items[j + pointer]);
                    }
                }
            });
        });

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        // стилизация input-file

        /* плагин для стилизации input[type='file'] */
        $.fn.bootstrapFileInput = function () {
            this.each(function (i, elem) {
                var $elem = $(elem);
                // Maybe some fields don't need to be standardized.
                if (typeof $elem.attr('data-bfi-disabled') != 'undefined') {
                    return;
                }
                // Set the word to be displayed on the button
                var buttonWord = 'Browse';
                if (typeof $elem.attr('title') != 'undefined') {
                    buttonWord = $elem.attr('title');
                }
                var className = '';
                if (!!$elem.attr('class')) {
                    className = ' ' + $elem.attr('class');
                }
                // Now we're going to wrap that input field with a Bootstrap button.
                // The input will actually still be there, it will just be float above and transparent (done with the CSS).
                if (!$(this).parent().hasClass('file-input-wrapper')) {
                    $elem.wrap('<div class="file-input-wrapper' + className + '"></div>').parent().prepend($('<span></span>').html(buttonWord));
                }
            })
            // After we have found all of the file inputs let's apply a listener for tracking the mouse movement.
            // This is important because the in order to give the illusion that this is a button in FF we actually need to move the button from the file input under the cursor. Ugh.
                .promise().done(function () {

                // As the cursor moves over our new Bootstrap button we need to adjust the position of the invisible file input Browse button to be under the cursor.
                // This gives us the pointer cursor that FF denies us
                $('.file-input-wrapper').mousemove(function (cursor) {

                    var input, wrapper,
                        wrapperX, wrapperY,
                        inputWidth, inputHeight,
                        cursorX, cursorY;

                    // This wrapper element (the button surround this file input)
                    wrapper = $(this);
                    // The invisible file input element
                    input = wrapper.find("input");
                    // The left-most position of the wrapper
                    wrapperX = wrapper.offset().left;
                    // The top-most position of the wrapper
                    wrapperY = wrapper.offset().top;
                    // The with of the browsers input field
                    inputWidth = input.width();
                    // The height of the browsers input field
                    inputHeight = input.height();
                    //The position of the cursor in the wrapper
                    cursorX = cursor.pageX;
                    cursorY = cursor.pageY;

                    //The positions we are to move the invisible file input
                    // The 20 at the end is an arbitrary number of pixels that we can shift the input such that cursor is not pointing at the end of the Browse button but somewhere nearer the middle
                    var moveInputX = cursorX - wrapperX - inputWidth + 20;
                    // Slides the invisible input Browse button to be positioned middle under the cursor
                    var moveInputY = cursorY - wrapperY - (inputHeight / 2);

                    // Apply the positioning styles to actually move the invisible file input
                    input.css({
                        left: moveInputX,
                        top: moveInputY
                    });
                });

                BODY.on('change', '.file-input-wrapper input[type=file]', function () {
                    var fileName;
                    fileName = $(this).val();

                    if (fileName === '') {
                        $(this).parent().removeClass('changed');
                    } else if (fileName === undefined) {
                        $(this).parent().removeClass('changed');
                    }
                    else {
                        $(this).parent().addClass('changed');
                    }

                });

            });

        };
        /* //плагин для стилизации input[type='file'] */

        /* // стилизация input-file */

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
        // ширина раскрывающегося списка
        //BODY.on('click', '.select-target', function(e){
        //  e.stopPropagation();
        //  var elWidth = $(this).width();
        //  $('.select-content').css({width: elWidth + 63 + 'px'});
        //});

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        // Подсказки: парсинг, позиционирование
        setTimeout(function () {
            $("[data-tooltip]").each(function (e) {
                if (!($(".form-services-block").has(this).length)) {
                    $(this).wrap('<div class="tooltip-wrapper"></div>');
                }
                var left = ($(this).width() + 25),
                    // top =  '30px',
                    elem = '<div class="btn-tooltip" style="left:' + left + 'px">?</div>';

                if ($(this)[0].tagName === "SELECT") {
                    left = $(this).parent().width() - 32;
                    elem = '<div class="btn-tooltip" style="left:' + left + 'px; top: 40px;">?</div>';
                    $(this).after(elem);
                } else if ($(this).parent().parent()[0].tagName === "LABEL") {
                    left = $(this).parent().next().width() + 35;
                    elem = '<div class="btn-tooltip" style="left:' + left + 'px">?</div>';
                    $(this).parent().parent().after(elem);
                } else if ($(this).parent().hasClass('input-wrapper')) {
                    left = $(this).parent().parent().width() + 35;
                    elem = '<div class="btn-tooltip" style="left:' + left + 'px">?</div>';
                    $(this).parent().parent().after(elem);
                } else {
                    $(this).after(elem);
                }
            });
        }, 2000);

        $('input').click(function (e) {
            e.stopPropagation();
        });


        BODY.on('click', '.btn-tooltip', function (e) {
            e.stopPropagation();

            $('.tooltip-modal').remove();
            var check = $(this).next().hasClass("tooltip-modal");
            if (check == false) {
                var tooltipContent = $(this).prev().attr('data-tooltip');
                if (tooltipContent !== undefined) {
                    BODY.append(' <div class="tooltip-modal"> ' +
                        '<div class="closed">X</div> ' +
                        '<div class="text-content">' + tooltipContent +
                        '</div>' +
                        ' </div>');
                } else {
                    tooltipContent = $(this).parent().find('input').attr('data-tooltip');
                    BODY.append(' <div class="tooltip-modal"> ' +
                        '<div class="closed">X</div> ' +
                        '<div class="text-content">' + tooltipContent +
                        '</div>' +
                        ' </div>');
                }


            }
            // настройки позиционирования tooltip
            var height = $('.tooltip-modal').height();
            var top = $(this).offset().top - height - 12;
            var left = $(this).offset().left - 28;
            $('.tooltip-modal').css({top: top + "px", left: left + "px"})


        });

        $(document.body).on('click', '.tooltip-modal .closed, #wrap', function () {
            $('.tooltip-modal').remove();

        });
        $(document.body).keydown(function (e) {
            if (e.which === 27) {
                $('.tooltip-modal').remove();
            }
        });

        $('.form-services-block .btn-tooltip').each(function (e) {
            var elem = $(this).parent().parent();
            var btn = $(this).detach();
            elem.append(btn);

            var left = $(this).prev().width() + 35;
            $(this).css({left: left + "px"})
        });

        // end Подсказки: парсинг, позиционирование

        BODY.on('click', '.toggle', function () {
            var context = $(this);
            var isClass = context.hasClass('toggle--show');
            if (isClass) {
                context.next('.toggle-block').slideToggle(function () {
                    context.removeClass('toggle--show');
                    context.addClass('toggle--hide');
                });

            } else {
                context.next('.toggle-block').slideToggle(function () {
                    context.removeClass('toggle--hide');
                    context.addClass('toggle--show');
                });
            }

        });

        // Поочередный показ в таблицах цен на услуги. Страницы юр.услуг
        $('.price--first, .price--second').hide();

        $(document).on('click', '.toggle-first', function () {
            $('.price--first').slideToggle();
            $('.price--second').slideToggle();
            // $('.toggle-block').slideToggle();
        });

        // $(document).on('click', '.toggle-second', function () {
            
        // });
        // END Поочередный показ цен

        $('.toggle-block').each(function () {
            $(this).after('<div class="clearfix"></div>')
        });

        $('.btn-card-file').on('click', function () {
            $('.card-file-popup').fadeIn();
        });

        $('.card-file-popup__close').on('click', function () {
            $('.card-file-popup').fadeOut();
        });


//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        function setPositionArrow() {
            if (!$('.slider-main').length) {
                return;
            }
            var leftPosition = $('.slider-main .stack').offset().left;
            $('.slider-main .slick-prev').offset({left: leftPosition - 150});
            $('.slider-main .slick-next').offset({left: leftPosition + 455});
        }
        $('.slider-main').on('init', function() {
            setPositionArrow();
        });

        $(window).on('resize', function () {
            setPositionArrow();
        });

        /**
         * Check if Selector is exist
         * @param selector
         * @type String
         * @returns {boolean}
         */
        function isSelector(selector) {
            return !!$(selector).length;
        }

        // Add class to service-page with list of subsections
        if (isSelector('.services-page .list-registration')) {
            $('#wrap').addClass('services-page__subsections');
        }

    });
})(jQuery);


// WEBPACK FOOTER //
// ./app.js